import styled from '@emotion/styled'
import { LifeStoriesGallery } from 'components/content/lifeStories/LifeStoriesGallery/LifeStoriesGallery'
import { Text } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SButtonsDiv = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  align-items: center;
  margin-top: 1.6875rem;

  @media ${BREAKPOINTS.MD.max} {
    & > button {
      flex: 1;
    }
  }
  & > button {
    min-width: 25%;
  }
  & > button:not(:first-of-type) {
    margin-right: ${pxToRem(24)}rem;
  }
`

export const SComposerModal = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const SMemoryList = styled(LifeStoriesGallery)`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`

export const SHeading = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${pxToRem(24)}rem;
`

export const STitle = styled(Text)`
  color: black;
  font-weight: bold;
  font-size: ${pxToRem(21)}rem;
  margin-left: ${pxToRem(12)}rem;
`

export const SGalleryActionsWrapper = styled.div`
  display: flex;
  padding-bottom: 1rem;

  & > :not(:first-child) {
    margin-left: 3rem;

    @media ${BREAKPOINTS.MD.max} {
      margin-left: 1rem;
    }
  }
`
